import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Formatter from "../../Localization/Formatter";
import Constants from "../../Action/Constants";

class ChargeTemplateUpdateWillMount extends Middleware implements MiddlewareInterface {
  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const chargeTemplate = this.component.props.chargeTemplate;

    if (this.component.props.chargeTemplateCreatedOnFrontend) {
      const chargeTemplateContact = this.component.props.app.persons.find(person => person.id === chargeTemplate.contactId);
      const chargeTemplateCompany = this.component.props.app.companies.find(company => company.id === chargeTemplate.companyId);

      this.component.setState({
        chargeTemplate: chargeTemplate,
        amount: chargeTemplate.amount,
        currency: chargeTemplate.currency,
        type: chargeTemplate.type,
        repeatPeriod: chargeTemplate.repeatPeriod,
        description: chargeTemplate.description,
        paymentOffset: chargeTemplate.paymentOffset,
        dueDateFirstPayment: chargeTemplate.dueDateFirstPayment,
        firstDate: chargeTemplate.firstDate ? chargeTemplate.firstDate : chargeTemplate.dueDateFirstPayment,
        endDate: chargeTemplate.endDate,
        isDefault: chargeTemplate.isDefault,
        error: chargeTemplate.error,
        isPaidDirectlyToOwner: chargeTemplate.isPaidDirectlyToOwner,
        isForContract: this.component.props.entity === "contract",
        isForUnit: this.component.props.entity === "unit",
        isForProperty: this.component.props.entity === "property",
        selectedCounterparty: !!chargeTemplateContact ? chargeTemplateContact : !!chargeTemplateCompany ? chargeTemplateCompany :  null,
        isCollective: chargeTemplate.isCollective,
        openCoachCreateNewCounterparty: false
      });
    } else {
      this.component.props.dispatch({
        type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR
      });
      
      this.component.setState({
        chargeTemplate: chargeTemplate,
        amount: Formatter.simpleFormatNumber(chargeTemplate.amount),
        currency: chargeTemplate.currency.getCurrencyId(),
        type: chargeTemplate?.type?.id,
        repeatPeriod: chargeTemplate?.repeatPeriod?.id,
        description: chargeTemplate.description,
        paymentOffset: chargeTemplate.paymentOffset?.getValue(),
        dueDateFirstPayment: chargeTemplate.dueDateFirstPayment,
        firstDate: chargeTemplate.firstDate ? chargeTemplate.firstDate : chargeTemplate.dueDateFirstPayment,
        endDate: chargeTemplate.endDate,
        isDefault: chargeTemplate.isDefault,
        isPaidDirectlyToOwner: chargeTemplate.isPaidDirectlyToOwner,
        isForContract: this.component.props.entity === "contract",
        isForUnit: this.component.props.entity === "unit",
        isForProperty: this.component.props.entity === "property",
        selectedPerson: chargeTemplate.contact,
        selectedCompany: chargeTemplate.company,
        selectedCounterparty: !!chargeTemplate.contact ? chargeTemplate.contact : !!chargeTemplate.company ? chargeTemplate.company :  null,
        isCollective: chargeTemplate.isCollective,
        openCoachCreateNewCounterparty: false
      });
    }
  }
}

export default new ChargeTemplateUpdateWillMount();
